import axios from 'axios';
import environment from 'environment';

import { JsonResponse } from 'core/models/response';
import { IncompetentsListResponse, Incompetent } from '../models/incompetents';

export const onGetIncompetents = (page: number = 1, search?: string) => {
	return axios.get<JsonResponse<IncompetentsListResponse>>(`${environment.BASE_API_ENDPOINT}/admin/incompetents`, {
		params: {
			page,
			search,
		},
	});
};

export const onGetIncompetentById = (incompetentId: string) => {
	return axios.get<JsonResponse<Incompetent>>(`${environment.BASE_API_ENDPOINT}/admin/incompetents/${incompetentId}`);
};

export const onDeleteIncompetent = (incompetentId: string) => {
	return axios.delete<JsonResponse<Incompetent>>(`${environment.BASE_API_ENDPOINT}/admin/incompetents/${incompetentId}`);
};

export const onRejectIncompetent = (incompetentId: string, rejection_reason: string) => {
	return axios.put<JsonResponse<Incompetent>>(`${environment.BASE_API_ENDPOINT}/admin/incompetents/reject/${incompetentId}`, {
		rejection_reason,
	});
};

export const onApproveIncompetent = (incompetentId: string) => {
	return axios.put<JsonResponse<Incompetent>>(`${environment.BASE_API_ENDPOINT}/admin/incompetents/approve/${incompetentId}`);
};

export const onUnlinkIncompetent = (incompetentId: string) => {
	return axios.put(`${environment.BASE_API_ENDPOINT}/admin/incompetents/unlink/${incompetentId}`);
};
